import React from 'react';
import { NavLink } from 'react-router-dom';

const AddLeaveRequestCrumb = () => (
  <NavLink to="/human-resources/leave-requests/add">Add Leave Request</NavLink>
);

export default AddLeaveRequestCrumb;
